import { Alert, AlertTitle, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import type { ExtractedDocumentPages } from '../../../services/goods-receiving/goods-receiving.types';
import { hasMissingDdtPages } from '../utils/ddt-pages-notice';

interface DdtPagesBannerProps {
  pages: ExtractedDocumentPages | null | undefined;
  onAddPages: () => void;
}

// Photos are added from the document step in "append pages" mode (see
// buildAppendPagesQuery): the stored photos stay, the lines are re-read from all
// pages and replace the current ones — the copy says so.
export function DdtPagesBanner({ pages, onAddPages }: DdtPagesBannerProps) {
  const { t } = useTranslation('goodsReceiving');
  if (!hasMissingDdtPages(pages)) {
    return null;
  }
  return (
    <Alert
      severity="warning"
      action={
        <Button color="inherit" size="small" onClick={onAddPages} sx={{ minHeight: 48 }}>
          {t('ddtPagesAddAction')}
        </Button>
      }
    >
      <AlertTitle>{t('ddtPagesMissingTitle')}</AlertTitle>
      {t('ddtPagesMissingBody')}
    </Alert>
  );
}
